import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import type { Editor } from '@tiptap/react';
import React from 'react';
import {
  FaCaretDown,
  FaCheck,
  FaFont,
  FaHeading,
  FaListOl,
  FaListUl,
  FaQuoteLeft,
} from 'react-icons/fa';

interface Props {
  editor: Editor;
}

export const NodeTypeSelect = (props: Props) => {
  const { editor } = props;

  const items = [
    {
      icon: FaHeading,
      title: 'Heading 1',
      action: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
      isActive: () => editor.isActive('heading', { level: 1 }),
    },
    {
      icon: FaHeading,
      title: 'Heading 2',
      action: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
      isActive: () => editor.isActive('heading', { level: 2 }),
    },
    {
      icon: FaHeading,
      title: 'Heading 3',
      action: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
      isActive: () => editor.isActive('heading', { level: 3 }),
    },
    {
      icon: FaHeading,
      title: 'Heading 4',
      action: () => editor.chain().focus().toggleHeading({ level: 4 }).run(),
      isActive: () => editor.isActive('heading', { level: 4 }),
    },
    {
      icon: FaFont,
      title: 'Text',
      action: () => editor.chain().focus().setParagraph().run(),
      isActive: () => editor.isActive('paragraph'),
    },
    {
      icon: FaListUl,
      title: 'Bullet List',
      action: () => editor.chain().focus().toggleBulletList().run(),
      isActive: () => editor.isActive('bulletList'),
    },
    {
      icon: FaListOl,
      title: 'Ordered List',
      action: () => editor.chain().focus().toggleOrderedList().run(),
      isActive: () => editor.isActive('orderedList'),
    },
    {
      icon: FaQuoteLeft,
      title: 'Blockquote',
      action: () => editor.chain().focus().toggleBlockquote().run(),
      isActive: () => editor.isActive('blockquote'),
    },
  ];

  const activeItem = P.run(() => {
    const activeItems = items.filter((item) => item.isActive());

    if (activeItems.length > 1) {
      const withoutParagraph = activeItems.filter((item) => item.title !== 'Paragraph');
      return P.first(withoutParagraph);
    }

    return P.first(activeItems);
  });

  return (
    <ChakraV3.Menu.Root positioning={{ placement: 'bottom' }} lazyMount>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='ghost' size='sm' rounded='lg' w='100px'>
          {activeItem?.title ?? 'Paragraph'}
          <ChakraV3.Spacer />
          <FaCaretDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content minW='160px'>
          {items.map((item) => (
            <ChakraV3.MenuItem
              value={item.title}
              key={item.title}
              onClick={item.action}
              py={1}
              px={2}
            >
              <item.icon />
              <ChakraV3.HStack w='full'>
                {item.title}
                <ChakraV3.Spacer />
                {item === activeItem && <FaCheck fontSize='10px' />}
              </ChakraV3.HStack>
            </ChakraV3.MenuItem>
          ))}
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
